import { render } from "./TimelineDemo.vue?vue&type=template&id=b0b146a4&scoped=true"
import script from "./TimelineDemo.vue?vue&type=script&lang=js"
export * from "./TimelineDemo.vue?vue&type=script&lang=js"

import "./TimelineDemo.vue?vue&type=style&index=0&id=b0b146a4&lang=scss&scoped=true"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0b146a4"]])

export default __exports__